Namespace('Monitoring.SharedSessions.SharedSessionContainer')

class Monitoring.SharedSessions.SharedSessionChartsView extends Backbone.View
  template: JST["backbone/templates/monitoring/shared_sessions/shared_session_charts"]
  className: 'shared-session-charts'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @total = @options.total
    @totalCount = @total
    @uniqueUsers = @options.uniqueUsers
    @uniqueUsersCount = @uniqueUsers
    @facets = @options.facets
    @tagsByClientCode = @options.tagsByClientCode
    @wordsRankingCalculator ||= new Monitoring.Views.Charts.WordsRankingCalculator({
      searchQuery: @searchQuery,
      facets: @facets
    })
    Highcharts.setOptions({
      global:
        useUTC: false
    })
    @charts = []

  render: ->
    @$el.html(@template(@))
    @renderAllCharts()
    @

  renderAllCharts: ->
    @charts = []
    @$el.html(@template(@))
    @chartContainer = @$el.find('#chart-container')

    charts = @searchQuery.get('charts')
    @createChart(chart) for chart in charts
    @masonry()

  createChart: (settings) ->
    chartOptions = @getChartOptions(settings)
    chartClass = Monitoring.Views.Charts[settings.class]
    try
      chart = new chartClass(chartOptions)
      chart.appendChart(@chartContainer)
      chart.bind('masonry', @masonry)
    catch error
      chart.displayError() if chart?
      console.log error
    @charts.push(chart) if chart?
    chart

  getChartOptions: (settings) ->
    {
      searchQuery: @searchQuery
      facets: @facets
      settings: _.extend({}, settings, { avoid_preview: true })
      tagsByClientCode: @tagsByClientCode
      calculator: @wordsRankingCalculator
      container: @
      showBenchmarkOption: false,
      readonly: true
    }

  masonry: =>
    setTimeout =>
      @chartContainer.masonry(
        columnWidth: '.grid-sizer'
        gutter: '.gutter-sizer'
        itemSelector: '.item'
      )
    , 100
